import { useEffect } from "react";
import { InputFilesCard } from "./card";
import { InputFilesNew } from "./new";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { InputFilesTable } from "./table";

export default function InputFiles() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Fichiers d'entrée");
  }, []);

  return (
    <Routes>
      <Route index element={<InputFilesTable />} />
      <Route path="/new" element={<InputFilesNew />} />
      <Route path=":id" element={<InputFilesCard />} />
    </Routes>
  );
}
